import { ROUTES_NAMES } from '@/constants';
import ConfirmSignUp from '@/views/ConfirmSignUp.vue';
import { beforeEnterConfirmRegistrationRoute } from './confirmRegistrationNavigationGuards';

const confirmRegistrationRoute = {
  path: '/confirm',
  name: ROUTES_NAMES.confirmSignUp,
  component: ConfirmSignUp,
  beforeEnter: beforeEnterConfirmRegistrationRoute
};

export default confirmRegistrationRoute;
